<!-- ScrollToTopArrow.svelte -->
<script>
  import { fly } from 'svelte/transition';

  let showArrow = false;
  let lastScrollY = 0;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > 300 && currentScrollY > lastScrollY) {
      showArrow = true;
    } else {
      showArrow = false;
    }

    lastScrollY = currentScrollY;
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
</script>

<svelte:window on:scroll={handleScroll} />

{#if showArrow}
  <button
    class="fixed top-16 left-1/2 -translate-x-1/2 z-10 rounded-full py-1 px-4 bg-orange-600 text-white transition-transform duration-300 hover:scale-110 shadow-xl text-sm font-semibold md:hidden"
    on:click={scrollToTop}
    transition:fly={{ y: 50, duration: 300 }}
  >
    <div class="">Back to Top</div>
  </button>
{/if}
